import React, { FC, useMemo } from 'react';
import { Dialog, DialogTitle, Grid, IconButton, Typography } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { DetailedTable } from './DetailedTable';
import { DetailsModel } from '../../MasteIBCommissionModel';
import { useStyles } from './styles';
import { ExportButtons } from '../../../../../components';

interface Props {
  translation: any;
  title: any;
  data: DetailsModel[];
  open: boolean;
  handleCancel: () => void;
}

export const MasterIbCommissionDialog: FC<Props> = ({ title, data, open, handleCancel, translation }) => {
  const classes = useStyles();
  const columnNames = useMemo(() => [translation.text_1666, translation.text_983, translation.text_984, translation.text_1665], [translation]);

  const renderTableData = (): string[][] => {
    const rows: string[][] = [];
    if (data.length > 0) {
      data.forEach((row) => {
        const tableRow: string[] = [
          row.subPartnershipCode ? row.subPartnershipCode : '-',
          row.depositUSD || row.depositUSD === 0 ? row.depositUSD.toFixed(2) : '-',
          row.withdrawalUSD || row.withdrawalUSD === 0 ? Math.abs(row.withdrawalUSD).toFixed(2) : '-',
          row.lastBalanceUSD || row.lastBalanceUSD === 0 ? row.lastBalanceUSD.toFixed(2) : '-',
        ];
        rows.push(tableRow);
      });
    }
    return rows;
  };

  return (
    <Dialog onClose={handleCancel} open={open} classes={{ paper: classes.dialog }}>
      <DialogTitle disableTypography className={classes.dialogTitle}>
        <Grid container justify="space-between" spacing={1} alignItems="center">
          <Grid item style={{ marginRight: 30 }}>
            <Typography variant="h6">{title}</Typography>
          </Grid>
          <Grid item>
            <Grid container justify="flex-end">
              <ExportButtons translation={translation} exportFileName={translation.text_6035} columns={columnNames} exportTableData={renderTableData()} reportNameInEn="Master IB Commission Details" isEnabled />
              <IconButton className={classes.closeBtn} onClick={handleCancel}>
                <Close />
              </IconButton>
            </Grid>
          </Grid>
        </Grid>
      </DialogTitle>
      <Grid container direction="column" className={classes.root}>
        <DetailedTable rows={data} reportColumns={columnNames} translation={translation} />
      </Grid>
    </Dialog>
  );
};
